import { render, staticRenderFns } from "./PostList.vue?vue&type=template&id=0786a2c7&scoped=true&lang=pug&"
import script from "./PostList.vue?vue&type=script&lang=ts&"
export * from "./PostList.vue?vue&type=script&lang=ts&"
import style0 from "./PostList.vue?vue&type=style&index=0&id=0786a2c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0786a2c7",
  null
  
)

export default component.exports